import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

function ModalCoupon({ isOpen, onClose, coupon, validateData, applyCoupon }) {
  const handleOnClose = () => {
    onClose(false);
  };

  const getMessage = () => {
    if (coupon && coupon.message) {
      if (coupon.message.toLowerCase().includes('expired')) {
        return 'The coupon has expired.';
      }
      return coupon.message;
    }
    return '';
  };

  return (
    <Modal isOpen={isOpen} toggle={handleOnClose} centered>
      <div>
        <div className="modal-header">
          <h5 className="modal-title">
            {coupon &&
            coupon.invalid &&
            coupon.message.toLowerCase().includes('expired')
              ? coupon.message
              : 'Coupon Not Valid'}
          </h5>
          <i className="icon-close" onClick={handleOnClose} />
        </div>
      </div>
      <div />
      <ModalBody className="modal-body">
        {getMessage()}
        <p className="support-info">
          For any questions or issues, please email us at{' '}
          <a href="mailto:support@promotionwingman.com">
            support@promotionwingman.com
          </a>
        </p>
      </ModalBody>
      <ModalFooter>
        {!applyCoupon}
        <div className="container-button">
          <Button
            className="btn-activate-subscription"
            size="xs"
            block
            onClick={handleOnClose}
          >
            Accept
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default ModalCoupon;
